import React from 'react';

const EffectOne = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M19 34.84C23.7717 34.84 27.64 30.9717 27.64 26.2C27.64 21.4283 23.7717 17.56 19 17.56C14.2282 17.56 10.36 21.4283 10.36 26.2C10.36 30.9717 14.2282 34.84 19 34.84Z" stroke="#FCEE21" strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M19 36.1C26.0582 36.1 31.78 30.3782 31.78 23.32C31.78 16.2618 26.0582 10.54 19 10.54C11.9418 10.54 6.22003 16.2618 6.22003 23.32C6.22003 30.3782 11.9418 36.1 19 36.1Z" stroke="#FCEE21" strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M19 36.1C28.4441 36.1 36.1 28.4441 36.1 19C36.1 9.55596 28.4441 1.90002 19 1.90002C9.55596 1.90002 1.90002 9.55596 1.90002 19C1.90002 28.4441 9.55596 36.1 19 36.1Z" stroke="#FCEE21" strokeWidth="2" strokeMiterlimit="10"/>
    </svg>
  )
};

export default EffectOne;
